import { render, staticRenderFns } from "./DownModel.vue?vue&type=template&id=e6cf4ec6&scoped=true&"
import script from "./DownModel.vue?vue&type=script&lang=js&"
export * from "./DownModel.vue?vue&type=script&lang=js&"
import style0 from "./DownModel.vue?vue&type=style&index=0&id=e6cf4ec6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6cf4ec6",
  null
  
)

export default component.exports